import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';

import { map, withLatestFrom, filter } from 'rxjs/operators';
import { Actions } from '../../actions';
import { GetAssetStatus } from '../action-creators';
import { GetTracksSuccess } from '../../tracks/action-creators';
import { GET_TRACKS_SUCCESS } from '../../tracks/actions';
import { NoOp } from '../../ui/action-creators';
import AppState from '../../state';

export const getStatusAfterGetTrackEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, GetTracksSuccess>(GET_TRACKS_SUCCESS),
    filter((action) => !action.disableCheck),
    withLatestFrom(state$),
    map(([action, state]) => {
      const category = 'audio';
      const ids = action.tracks
        .filter((t) => {
          if (!t.id) {
            return false;
          }

          if (t.id in state.assets.statuses) {
            const status = state.assets.statuses[t.id];

            return !status.validationDone;
          }

          return true;
        })
        .map((t) => t.id);

      if (!ids.length) {
        return new NoOp();
      }

      return new GetAssetStatus(category, ids as string[]);
    })
  );
